import { Button, CheckIcon, CompareIcon } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import type { MouseEvent } from 'react';

import styles from './compareToggle.module.css';

interface CompareToggleProps {
  disabled?: boolean;
  isSelected: boolean;
  onToggle: () => void;
  productName: string;
}

/**
 * Round compare button overlaid on the product image, used by legacy cards
 * (Marketplace, Boost, and Bloom with custom components off). The shared
 * ProductCard offers compare through its overflow menu instead — see
 * `CompareMenuItem` and the card's `SelectedIndicator`.
 */
export const CompareToggle = ({
  disabled = false,
  isSelected,
  onToggle,
  productName,
}: CompareToggleProps) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle();
  };

  return (
    <Button.Icon
      className={clsx(styles['toggle'], {
        [styles['toggle__active']]: isSelected,
      })}
      disabled={disabled}
      icon={isSelected ? <CheckIcon size="sm" /> : <CompareIcon size="sm" />}
      onClick={handleClick}
      aria-label={`Compare ${productName}`}
      aria-pressed={isSelected}
    />
  );
};
